import React from 'react';
import { Icon, IconComponent } from './icon';
import src from 'grpn-mx-mixer/dist/images/icons/comments.svg';

export const IconComments: IconComponent = props => <Icon {...props} src={src} />;
